import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoldIcon, WarningBoldIcon } from '@pattern-library/icon';
import FeedbackMessage from '@pattern-library/feedback-message';
const propTypes = {
  /**
   * The ID of the container element, used for an accessibility description of the corresponding input
   */
  containerId: PropTypes.string.isRequired,
  /**
   * The severity of the input's error state
   */
  errorLevel: PropTypes.oneOf(['error', 'warning']),
  /**
   * Error message(s) to display when `hasError` is enabled
   */
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  /**
   * Class for the feedback message container
   */
  messageClassname: PropTypes.string,
  /**
   * Icon to display in the feedback message
   */
  messageIcon: PropTypes.elementType,
  /**
   * Flag to enable the input's error state
   */
  hasError: PropTypes.bool
};
function FormInputErrors(_ref) {
  let {
    containerId,
    errorLevel = 'error',
    errorMessage,
    hasError,
    messageClassname = '',
    messageIcon = null
  } = _ref;
  let errorMessages = Array.isArray(errorMessage) ? errorMessage : [errorMessage];
  errorMessages = errorMessages.filter(message => typeof message === 'string' && message.trim().length > 0);
  const hasErrorMessages = errorMessages.length > 0;
  if (hasError && hasErrorMessages) {
    const FeedbackIcon = messageIcon ?? errorLevel === 'error' ? ErrorBoldIcon : WarningBoldIcon;
    return /*#__PURE__*/React.createElement("div", {
      id: containerId
    }, errorMessages.map((message, index) => /*#__PURE__*/React.createElement("div", {
      key: `${index}`,
      className: "asc-form-help"
    }, /*#__PURE__*/React.createElement(FeedbackMessage, {
      className: messageClassname,
      icon: FeedbackIcon,
      level: errorLevel
    }, message))));
  }
  return null;
}
FormInputErrors.propTypes = propTypes;
export default FormInputErrors;